// filepath: apps/web/src/features/directory/people-directory/PeopleDirectoryRoute.tsx
//
// FR-UI-DIR-1 AC-1 — route shell for /people.

import { PeopleDirectoryPage } from "./PeopleDirectoryPage";

export function PeopleDirectoryRoute(): React.ReactElement {
  return <PeopleDirectoryPage />;
}
